module.exports = __webpack_public_path__ + "img/tiger-bg.240bb0f9.jpg";